import UnpaidReceiptsStatsPanel from './UnpaidReceiptsStatsPanel';

export default UnpaidReceiptsStatsPanel;
